import { render, staticRenderFns } from "./AddOrUpdateModal.vue?vue&type=template&id=a8f1485e"
import script from "./AddOrUpdateModal.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports